<!-- <kendo-loader *ngIf="loadSpinner" size="large" type="converging-spinner" class="load-spinner"></kendo-loader> -->
<!-- <div class="card-section header-styles" *ngIf="studentDetails">
  <div class="example-configs" [ngClass]="{
      'bg-orange': studentData?.caseStage === 'Reevaluation',
      'bg-green': studentData?.caseStage === 'Annual',
      'bg-blue': studentData?.caseStage === 'Initial',
      'bg-gray': studentData?.caseStage === 'Triennial',
      'bg-lightGray': studentData?.caseStage === 'Active'
    }"> -->
    <!---TODO: Revisit this with @Vadim for below role="img"---->
    <!-- <div class="top">
      <p class="!k-font-semibold">{{ studentData?.caseStage }}</p>
      <div class="icons-group" kendoTooltip position="bottom">
        <kendo-avatar size="small" rounded="none" role="img" [svgIcon]="hand"
          class="iconsList hand {{ studentData?.referralColor }}" fillMode="none" title="Referrals"></kendo-avatar>
        <kendo-avatar size="small" rounded="none" role="img" class="iconsList {{ studentData?.evalColor }}"
          [svgIcon]="magnifyingGlass" fillMode="none" title="Evaluations"></kendo-avatar>
        <kendo-avatar size="small" rounded="none" role="img" [svgIcon]="fileSignature"
          class="iconsList {{ studentData?.iepColor }}" fillMode="none" title="IEP"></kendo-avatar>
        <kendo-avatar size="small" rounded="none" role="img" [svgIcon]="graduationCap"
          class="iconsList {{ studentData?.placementColor }} graduationCap" fillMode="none"
          title="Placement"></kendo-avatar>
      </div>
    </div>
  </div>

  <div class="example-config">
    <div class="student-info-container">
      <div class="col">
        <h4 class="margin-0 primary-color font-18">
          {{ studentData?.lastName }}, {{ studentData?.firstName }}
        </h4>
        <p class="secondary-color">
          Student ID:
          {{ studentData?.nycid }}
          | DOB:
          {{ studentData?.dob | date : "MM/dd/yyyy" }}
        </p>
        <p class="secondary-color">
          DBN: {{ studentData?.dbn }} | {{ studentData?.district }}
        </p>
        <p class="secondary-color">
          Grade: {{ studentData?.grade || studentDetails?.grade }}
        </p>
        <p class="secondary-color">
          School: {{ studentData?.school || studentDetails?.schoolName }}
        </p> -->
        <!----Dev: Uncomment if required, rightnow no details from an API---->
        <!-- <button class="!k-p-1" [svgIcon]="location" fillMode="flat" kendoButton kendoPopoverAnchor title="Location"
          [popover]="locationPopover" size="medium">
          </button>
        <kendo-popover #locationPopover>
          <ng-template kendoPopoverBodyTemplate>
            <p class="label secondary-color font-12 !k-my-1">Physical DBN</p>
            <p style="font-weight: 600;" class="!k-my-1">[{{studentData?.dbn}}] School Name</p>
            <p class="!k-my-1">prem@gmail.com
              <button class="!k-p-1" [svgIcon]="copy" fillMode="flat" kendoButton kendoPopoverAnchor title="Copy"
              size="medium" (click)="copyClipboard('prem@gmail.com')"></button>
          </p>
          </ng-template>
        </kendo-popover>
      </div> -->
      <!-- <div class="col">
        <p class="label secondary-color font-12">Assigned To</p>
        <div *ngIf="studentData?.assigned && studentData?.caseAssdFirstName && studentData?.caseAssdLastName">
          <p>{{ studentData?.caseAssdFirstName+' '+studentData?.caseAssdLastName}}
            <button class="!k-p-0" [svgIcon]="addressBook" fillMode="flat" kendoButton kendoPopoverAnchor
              title="Contact" #popoverAnchor="kendoPopoverAnchor" (click)="popoverAnchor.show()"
              [popover]="addressPopover" size="medium">
            </button>
          </p>

          <kendo-popover #addressPopover>
            <ng-template kendoPopoverBodyTemplate>
              <div class="!k-d-flex k-justify-content-between  k-align-items-end">
                <p style="font-weight: 600;" class="!k-my-0">{{ studentData?.caseAssdFirstName+'
                  '+studentData?.caseAssdLastName}}</p>

                <button kendoButton fillMode="flat" [svgIcon]="xIcon" size="small" (click)="popoverAnchor.hide()"
                  title="Close"></button>
              </div>
                <p class="caseAssdRole k-my-1">{{studentData?.caseAssdRole}}</p>
              <p class="!k-mt-0 !k-mb-3">{{studentData?.caseAssdEmail}}
                <button class="!k-p-0" [svgIcon]="copy" fillMode="flat" kendoButton size="medium"
                  (click)="copyClipboard(studentData?.caseAssdEmail)" title="Copy">
                </button>
              </p> -->
              <!-- <p class="!k-mt-1">prem@gmail.com Dev: Undo if required in student header also, commented as backend dev suggested that no email in student header.
              <button class="!k-p-1" [svgIcon]="copy" fillMode="flat" kendoButton size="medium" (click)="copyClipboard(studentData?.caseAssdEmail)" title="Copy">
              </button>
            </p> -->
            <!-- </ng-template>
          </kendo-popover>
        </div>
        <div *ngIf="!studentData?.assigned" class="!k-mt-1">
          <span class="k-font-semibold k-text-error">Unassigned</span>
          <button kendoButton *ngIf="user?.isGlobalUser" tabindex="0"
            class="!k-p-0 k-text-primary k-cursor-pointer assign-btn" fillMode="link"
            (click)="showReAssign$.next(true)">(Assign)</button>
        </div>
      </div>
      <div class="col" *ngIf="isPreschool">
        <p class="label secondary-color font-12">Evaluation Site</p>
        <p>{{ studentData?.evaluationSite }}</p>
      </div>

      <div class="activity-col">
        <p class="label secondary-color font-12">Activity</p>
        <p>{{ studentData?.activity }}</p>
      </div>
      <div class="date-cols">
        <p class="label secondary-color font-12">Activity Due Date</p>
        <ng-container *ngIf="dueDatesArray?.length">
          <ng-container *ngFor="let obj of dueDatesArray">
            <p class="font-14" [class.at-risk]="studentData.complianceStatus === 'At Risk'" [class.k-text-error]="
                studentData.complianceStatus === 'Out of Compliance'
              " [class.reason-for-delay]="
                studentData.complianceStatus === 'Reason for Delay'
              ">
              <fa-icon *ngIf="studentData.complianceStatus === 'At Risk'" [icon]="circleExclamation"
                title="At Risk"></fa-icon>
              <fa-icon *ngIf="studentData.complianceStatus === 'Out of Compliance'" icon="triangle-exclamation"
                title="Out of compliance"></fa-icon>
              <fa-icon *ngIf="studentData.complianceStatus === 'Reason for Delay'" icon="hourglass-half"
                title="Reason for Delay"></fa-icon>
              {{ obj?.descr }}: {{ obj?.date }}<br />
              ({{ obj?.days }} {{ getDayLabel(obj?.days) }})
            </p>
          </ng-container>
        </ng-container>
      </div>
      <div class="date-cols">
        <p class="label secondary-color font-12">Compliance Date</p>
        <ng-container *ngIf="complianceDatesArray?.length">
          <ng-container *ngFor="let obj of complianceDatesArray">
            <p class="font-14" [class.k-text-error]="obj?.days?.startsWith('-')">
              <fa-icon *ngIf="obj?.days?.startsWith('-')" icon="triangle-exclamation"></fa-icon>
              {{ obj?.descr }}: {{ obj?.date }}<br />
              ({{ obj?.days }} {{ getComplianceDayLabel(obj?.days) }})
            </p>
          </ng-container>
        </ng-container>
      </div> -->
      
  <div class="k-d-flex k-gap-4 k-flex-row-reverse">
    <div class="actions-col" *ngIf="showAction && isStudentSKValid()">
        <button size="large" kendoButton #anchor [themeColor]="'primary'" fillMode="solid" (click)="loadActions($event)">
          <kendo-loader *ngIf="loading.actions" size="small"> </kendo-loader>
          Actions
          <kendo-contextmenu [target]="anchor" size="large" showOn="click">
            <ng-template kendoContextMenuTemplate>
              <app-custom-actions [actionsList]="actionsList" [studentDetails]="studentData"
                (scheduleMeetingDialog)="showScheduleMeetingDialog$.next($event)"
                (cancelMeetingDialog)="showCancelMeetingDialog$.next($event)"
                (closeRequestForReevaluationDialog)="showCloseRequestForReevaluationDialog$.next($event)"
                (caseClosingEventsDialog)="showCaseClosingEventsDialog$.next($event)"
                (captureFirstAttendDate)="showCaptureFirstAttendDate$.next($event)"
                (reAssign)="showReAssign$.next($event)" (uploadDialog)="showUpload$.next($event)"
                (amendIEPDialog)="openAmendDialog($event)" (annualIEPDialog)="openAnnualDialog($event)"
                (meetingType)="meetingType = $event" (meetingSk)="meetingSk = $event" (isViewMode)="isViewMode = $event"
                (actionText)="actionText = $event" (meetingRoster)="meetingRoster = $event" (pwn)="pwn = $event"
                (isReAssign)="isReAssign = $event">
              </app-custom-actions>
            </ng-template>
          </kendo-contextmenu>
        </button>
        <div #container></div>
      </div>
    <kendo-dropdownbutton themeColor="base" class="btnChange" [data]="manageStudentsData"  *ngIf="showEditStudentInformation"
      (itemClick)="onSelect($event)" size="large" rounded="large" fillMode="solid">
      Manage
    </kendo-dropdownbutton>
  </div>
          <!-- </div>
  </div>
</div> -->
<div class="new-student-info-container">
  <div class="student-summary-container" [class.red-alert-header]="redAlertContact"
  [class.case-closed-header]="isCaseClosed" *ngIf="studentDetails">
  <div class="student-avatar" [class.avatar-red-alert]="redAlertContact" [class.avatar-inactive]="isCaseClosed">
    <fa-icon icon="user-graduate" class="avatar-fa-icon"></fa-icon>
  </div>

  <div class="student-summary-card">
    <div class="student-basic-info">
      <div class="student-details">
        <h1 class="margin-0">
          {{ studentData?.lastName }}
          {{ studentData?.firstName }}
          <span *ngIf="studentData?.eiid !== null" class="tag">EI</span>
          <span *ngIf="studentData?.hasKIP" class="tag secondary">KIP</span>
          <span *ngIf="redAlertContact" class="red-alert-badge">
            Red Alert
          </span>
          <span *ngIf="isCaseClosed" class="inactive-badge"> Inactive </span>
        </h1>

        <p class="secondary-color">
          ID: {{ studentData?.nycid }} | DOB:
          {{ studentData?.dob | date : "MM/dd/yyyy" }} | Grade:
          {{ studentData?.gradeValue || studentDetails?.gradeValue }} | DBN:
          {{ studentData?.dbn }} | District:
          {{ studentData?.district }}
        </p>
      </div>
    </div>
    <div class="student-iep-info">
      <div class="info-block">
        <p class="info-label">Disability Classification</p>
        <p class="info-value">{{ studentIEP?.classification }}</p>
      </div>

      <div class="info-block">
        <p class="info-label">IEP Placement Recommendation</p>
        <p class="info-value">{{ studentIEP?.placementRecommendations }}</p>
      </div>

      <div class="info-block">
        <p class="info-label">Assigned To</p>
        <div *ngIf="
            studentData?.assigned &&
            studentData?.caseAssdFirstName &&
            studentData?.caseAssdLastName
          ">
          <p class="info-value">
            {{
            studentData?.caseAssdFirstName +
            " " +
            studentData?.caseAssdLastName
            }}
            <button class="!k-p-0" [svgIcon]="addressBook" fillMode="flat" kendoButton kendoPopoverAnchor
              title="Contact" #popoverAnchor="kendoPopoverAnchor" (click)="popoverAnchor.show()"
              [popover]="addressPopover" size="medium"></button>
          </p>

          <kendo-popover #addressPopover>
            <ng-template kendoPopoverBodyTemplate>
              <div class="!k-d-flex k-justify-content-between k-align-items-end">
                <p style="font-weight: 600" class="!k-my-0">
                  {{
                  studentData?.caseAssdFirstName +
                  "
                  " +
                  studentData?.caseAssdLastName
                  }}
                </p>

                <button kendoButton fillMode="flat" [svgIcon]="xIcon" size="small" (click)="popoverAnchor.hide()"
                  title="Close"></button>
              </div>
              <p class="!k-mt-0 !k-mb-3">
                {{ studentData?.caseAssdEmail }}
                <button class="!k-p-0" [svgIcon]="copy" fillMode="flat" kendoButton size="medium"
                  (click)="copyClipboard(studentData?.caseAssdEmail)" title="Copy"></button>
              </p>
            </ng-template>
          </kendo-popover>
        </div>
      </div>
      <div class="info-block">
        <p class="info-label">Next Annual Review</p>
        <p class="info-value">{{ studentIEP?.annualRevDate | formatDate }}</p>
      </div>
      <div class="info-block">
        <p class="info-label">EI Extension Date</p>
        <p class="info-value">{{ studentIEP?.extensionDate | formatDate }}</p>
      </div>
    </div>
  </div>
</div>
<div class="student-status-strip" [class.red-alert-strip]="redAlertContact" *ngIf="!isCaseClosed && studentDetails">
  <div class="status-container">
    <span class="stage-text">
      {{ studentData?.caseStage }}
    </span>

    <div class="icons-group" kendoTooltip position="bottom">
      <kendo-avatar size="small" rounded="none" fillMode="none" [svgIcon]="hand"
        class="iconsList hand {{ studentData?.referralColor }}" title="Referrals">
      </kendo-avatar>

      <kendo-avatar size="small" rounded="none" fillMode="none" [svgIcon]="magnifyingGlass"
        class="iconsList {{ studentData?.evalColor }}" title="Evaluations">
      </kendo-avatar>

      <kendo-avatar size="small" rounded="none" fillMode="none" [svgIcon]="fileSignature"
        class="iconsList {{ studentData?.iepColor }}" title="IEP">
      </kendo-avatar>

      <kendo-avatar size="small" rounded="none" fillMode="none" [svgIcon]="graduationCap"
        class="iconsList {{ studentData?.placementColor }}" title="Placement">
      </kendo-avatar>
    </div>

    <span>|</span>

    <span class="stage-text"> {{ studentData?.activity }}</span>
    <span class="k-mx-2">|</span>
  </div>
  <!--<div class="k-d-flex">
    <span class="alert k-d-flex k-align-items-center">
      <fa-icon icon="triangle-exclamation" style="font-size: 14px"></fa-icon>Schedule IEP Meeting: 07/29/2025 (-91 Days)
    </span>
    <span class="k-mx-2">|</span>
    <span class="alert k-d-flex k-align-items-center">
      <fa-icon icon="triangle-exclamation" style="font-size: 14px"></fa-icon>Request Placement: 09/11/2025 (-19 Days)
    </span>
  </div>-->
</div>

<div class="studentProfile" *ngIf="studentDetails">
  <div class="container red-alert k-p-4 form-error" *ngIf="redAlertContact">
    <p class="!k-m-0 !k-font-semibold">
      There is a Red Alert associated with this student. The following adult(s)
      cannot have access to the student or any identifying information
      associated with the student:
    </p>
    <p class="!k-m-0 !k-font-semibold">
      1. {{ redAlertContact?.firstName }} {{ redAlertContact?.lastName }}
    </p>
    <p class="!k-m-0 !k-font-semibold">
      Keep student information from view of the adult(s) listed above and close
      the student information screen.
    </p>
  </div>
</div>
<div class="container-style" *ngIf="studentData?.studentStatus === 'Closed'">
  <div class="case-close-card">
    <button kendoButton size="medium" themeColor="dark" rounded="large" class="back-color">
      CASE CLOSED
    </button>
    <div class="k-d-row">
      <div>
        <b>
          {{ studentData?.firstName }}'s case was closed on
          {{ studentData?.caseCloseDate | date : "MM/dd/yyyy" }}.
        </b>
      </div>
      <div class="k-d-flex k-gap-2">
        <div>Total closures: {{ studentData?.noOfClosures }}</div>
        <div>|</div>
        <div>Reason: {{ studentData?.reasonforCasecloseDesc }}</div>
      </div>
    </div>
  </div>
</div>
</div>

<app-reassign-dialog *ngIf="showReAssign$ | async" (closeDialog)="showReAssign$.next(false)"
  [studentSk]="studentDetails?.studentSk" [nycId]="nycId" [isReAssign]="isReAssign">
</app-reassign-dialog>

<app-capture-first-attend-date-dialog [nycId]="nycId" *ngIf="showCaptureFirstAttendDate$ | async"
  (closeDialog)="showCaptureFirstAttendDate$.next(false)">
</app-capture-first-attend-date-dialog>

<app-document-upload *ngIf="showUpload$ | async" (closeDialog)="showUpload$.next(false)" [studentDetails]="studentDetails"
  [referralSk]="referralSk" [nycId]="nycId"></app-document-upload>

<kendo-dialog *ngIf="showCloseRequestForReevaluationDialog$ | async"
  (close)="showCloseRequestForReevaluationDialog$.next(false)" class="shm-window" [maxWidth]="1900" [width]="700"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'"
  title="Close Request for Reevaluation">
  <app-close-request-for-reevaluation [referralSk]="referralSk" [iepType]="pwn"
    (closeDialog)="showCloseRequestForReevaluationDialog$.next(false)">
  </app-close-request-for-reevaluation>
</kendo-dialog>

<kendo-dialog *ngIf="showCancelMeetingDialog$ | async" (close)="showCancelMeetingDialog$.next(false)" class="shm-window"
  (keydown.enter)="$event.stopPropagation()" (click)="$event.stopPropagation()" [maxWidth]="1900" [width]="1400"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'"
  title="Cancel Meeting">
  <app-cancel-meeting [studentSk]="studentSk" (closeDialog)="showCancelMeetingDialog$.next(false)">
  </app-cancel-meeting>
</kendo-dialog>

<app-schedule-meeting [nycIds]="nycId" *ngIf="showScheduleMeetingDialog$ | async"
  (closeEmitter)="showScheduleMeetingDialog$.next(false)" [meetingType]="meetingType" [referralSk]="referralSk"
  [meetingSk]="meetingSk" [viewMode]="isViewMode" [regComplianceDate]="studentData?.complianceDate"
  [caseStage]="studentDetails?.caseStage" [meetingRoster]="meetingRoster" [actionText]="actionText">
</app-schedule-meeting>

<kendo-dialog title="Case Closing" *ngIf="showCaseClosingEventsDialog$ | async"
  (close)="showCaseClosingEventsDialog$.next(false)" [maxWidth]="1900" [width]="800" [minHeight]="300"
  [animation]="{ duration: 300, type: 'fade', direction: 'down' }">
  <app-case-closing [studentSk]="studentDetails?.studentSk" [complianceStatus]="studentData?.complianceStatus"
    [referralSk]="referralSk" (closeDialog)="showCaseClosingEventsDialog$.next(false)">
  </app-case-closing>
</kendo-dialog>


<kendo-dialog *ngIf="showAmendDialog$ | async" [width]="550" [height]="250" [minWidth]="350"
  (close)="onAmendDialogClose($event)" title="Are you sure">
  <p>This action will create an IEP Amendment, do you want to proceed?</p>

  <kendo-dialog-actions>
    <button kendoButton (click)="onAmendDialogClose({ text: 'No' })">No</button>
    <button kendoButton themeColor="primary" (click)="onAmendDialogClose({ text: 'Yes' })">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="showAnnualDialog$ | async" [width]="550" [height]="250" [minWidth]="350"
  (close)="onAnnualDialogClose($event)" title="Are you sure">

  <p>This action will create a new Annual Review IEP, do you want to proceed?</p>

  <kendo-dialog-actions>
    <button kendoButton (click)="onAnnualDialogClose({ text: 'No' })">No</button>
    <button kendoButton themeColor="primary" (click)="onAnnualDialogClose({ text: 'Yes' })">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
<app-edit-student-profile [studentDetails]="studentDetails" *ngIf="showEditStudentProfileDialog"
  (closeDialog)="closeEditStudentProfileDialog()">
</app-edit-student-profile>